"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const one_1 = require("remax/one");
const common_1 = require("../common");
const icon_1 = __importDefault(require("../icon"));
const prefixCls = common_1.getPrefixCls('checkbox');
const Checkbox = (props) => {
    const { children, checked, value, extra, style, onChange } = props;
    const handleClick = (e) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(!checked, e, value);
    };
    return (React.createElement(one_1.View, { className: prefixCls, style: style },
        React.createElement(one_1.View, { className: `${prefixCls}-container`, onTap: handleClick },
            checked ? (React.createElement(icon_1.default, { type: "roundcheckfill", size: "48px", color: "#1890FF" })) : (React.createElement(icon_1.default, { type: "round", size: "48px", color: "#999" })),
            children ? React.createElement(one_1.View, { className: `${prefixCls}-container-label` }, children) : null),
        React.createElement(one_1.View, { className: `${prefixCls}-extra` }, extra)));
};
const getCheckboxs = (children, value = [], onChange) => {
    const onGroupChange = (checked, e, v) => {
        const newValue = (value === null || value === void 0 ? void 0 : value.includes(v)) ? value === null || value === void 0 ? void 0 : value.filter(i => i !== v) : value === null || value === void 0 ? void 0 : value.concat(v);
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue, e);
    };
    const checkboxs = React.Children.map(children, (checkbox) => {
        var _a;
        const p = (checkbox === null || checkbox === void 0 ? void 0 : checkbox.props) || {};
        let checked = p.checked;
        if ((p.value || p.value === 0) && ((_a = value) === null || _a === void 0 ? void 0 : _a.includes(p.value))) {
            checked = !checked;
        }
        return Object.assign(Object.assign({}, checkbox), { props: Object.assign(Object.assign({}, checkbox.props), { checked, onChange: onGroupChange }) });
    });
    return checkboxs;
};
Checkbox.Group = (props) => {
    const { value = [], children, direction = 'row', onChange } = props;
    const checkboxs = getCheckboxs(children, value, onChange);
    return (React.createElement(one_1.View, { style: {
            display: 'flex',
            flexDirection: direction,
        } }, checkboxs));
};
exports.default = Checkbox;
// 注意不要加 React.memo，会导致保错。
